import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {

  const token = sessionStorage.getItem("authToken");
 
  if (!token) {
    // Redirect to the login page if no token is found
    return <Navigate to="/" />;
  }

  // If the token exists, render the children components (e.g., Dashboard)
  return children;
};

export default ProtectedRoute;
